<template>
    <div class="footer">
        <div>    
            <span>Copyright © 2021 h5mota.com</span> |
            <a href="https://jq.qq.com/?_wv=1027&k=nJMrECRy" target="_blank">H5魔塔交流群</a> |
            <a href="https://space.bilibili.com/494596570" target="_blank">b站官方号</a>
        </div>
        <div>陕ICP备18008020号-1</div>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
.footer {
    margin-top: auto;
}
.footer {
    width: 100%;
    margin-left: 0px;
    margin-right: 0px;
    line-height: 1.45;
    background: #C8C8C8;
    padding: 10px;
    text-align: center;
}
a, span {
    margin: 0px 10px;
    color: #444444;
}
</style>